// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface ApiToken {
  id: number;
  name: string;
  description: string | null;
  prefix: string;
  is_active: boolean;
  created_at: string | null;
  expires_at: string | null;
  last_used_at: string | null;
  is_expired: boolean;
  user_id: number;
}

export interface CreatedApiToken {
  id: number;
  name: string;
  token: string; // en clair, affiché une seule fois par l'API
  prefix: string;
  user_login: string;
  expires_at: string | null;
}

export interface CreateApiTokenInput {
  name: string;
  description?: string;
  user_login: string;
  expires_in_days?: number;
}

async function callApi(path: string, method: 'GET' | 'POST' | 'DELETE', accessToken: string, body?: any): Promise<any> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

class ApiTokenService {

  async list(accessToken: string): Promise<ApiToken[]> {
    const json = await callApi('/admin/tokens', 'GET', accessToken);
    return json.data;
  }

  async create(input: CreateApiTokenInput, accessToken: string): Promise<CreatedApiToken> {
    const json = await callApi('/admin/tokens', 'POST', accessToken, input);
    return json.data;
  }

  async revoke(tokenId: number, accessToken: string): Promise<void> {
    await callApi(`/admin/tokens/${tokenId}/revoke`, 'POST', accessToken);
  }
}

export const apiTokenService = new ApiTokenService();
